import {ApiGatewayRepository} from './apiGatewayRepository'


const repository = {
    apiGateway: new ApiGatewayRepository(),
}

const RepositoryFactory = {
    get: (name) => repository[name],
}

export default RepositoryFactory